import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IAutoSaveDrawer } from './drawer-title.data';

@Component({
  selector: 'i2g-drawer-title',
  templateUrl: 'drawer-title.component.html',
  styleUrls: ['drawer-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DrawerTitleComponent {
  @Input() title: string;
  @Input() autoSave: IAutoSaveDrawer;
}
